<template>
  <section class="viewsrhqy_Calling p-4 space-y-2">
    <viewTitle title="业务管理 / 叫号管理" :showReturn="false"/>
    <div class="flex justify-between items-center">
      <span class="space-x-10">
        <span class="text-yellow-600">未呼叫：{{ countMap["wait_calling_num"] }}</span>
      </span>
      <span>
        <el-button v-has="['c-calling-record-specialCall']" @click="onSpecialCalling()"
                   size="small">特殊叫号</el-button>
        <el-button v-has="['c-calling-record-calling']" @click="onCalling()" type="primary"
                   size="small">叫号</el-button>
      </span>
    </div>
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item label="预约单号">
        <el-input clearable v-model="queryParam.code" placeholder="请输入预约单号" class="w-60"></el-input>
      </el-form-item>
      <el-form-item label="预约业务名称">
        <!-- <el-input
          clearable
          v-model="queryParam.car_business_name"
          placeholder="请输入车辆业务类型名称"
          class="w-60"
        ></el-input> -->
        <el-select placeholder="请选择预约业务名称" v-model="queryParam.business_id" filterable remote clearable
                   reserve-keyword :remote-method="getBusinessList" :loading="business_loading" @change="onBusinessChange">
          <el-option v-for="item in business_list" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车辆业务类型">
        <!-- <el-input
          clearable
          v-model="queryParam.car_business_name"
          placeholder="请输入车辆业务类型名称"
          class="w-60"
        ></el-input> -->
        <el-select placeholder="请选择车辆业务类型" v-model="queryParam.car_business_ids" multiple filterable remote clearable
                   reserve-keyword :remote-method="getCarBusinessList" :loading="car_business_loading">
          <el-option v-for="item in car_business_list" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车辆类型">
        <el-select class="w-60" clearable v-model="queryParam.vehicle_type" placeholder="请选择车辆类型">
          <el-option v-for="car in vehicleTypes" :key="car.id" :label="car.name" :value="car.id"></el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="预约业务">-->
<!--        <el-input clearable v-model="queryParam.business_name" placeholder="请输入预约业务名称" class="w-60"></el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="物料类型">
        <el-input clearable v-model="queryParam.chip_type" placeholder="请输入物料类型" class="w-48"></el-input>
      </el-form-item>
      <el-form-item label="车牌号">
        <el-input clearable v-model="queryParam.license_plate" placeholder="请输入车牌号" class="w-60"></el-input>
      </el-form-item>
      <el-form-item label="登记时间">
        <el-date-picker class="!w-96" style="margin-bottom: 10px;" v-model="timeRange" type="datetimerange"
                        align="right" unlink-panels range-separator="至" :default-time="['00:00:00', '23:59:59']"
                        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                        value-format="timestamp">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refreshData" size="small">刷新数据
        </el-button>
        <el-button @click="onReset" size="small">重置</el-button>
      </el-form-item>
    </el-form>
    <c-table class="mt-4" :isIndex="true" :isSelection="true" :selection.sync="rowKeySelection" :data="dataSource"
             :columns="columns" :query.sync="pagintion" :total="total" row-key="booking_id" @loadPage="loadData">
      <template slot="report_time" slot-scope="{ row }">
        {{ row.report_time | timeFormat }}
      </template>
      <template slot="business_list" slot-scope="{ row }">
        <div v-for="business in row.business_list">{{ business.name }}</div>
      </template>
      <template slot="action" slot-scope="{ row }">
        <div class="space-x-4">
          <c-link @click="onSpecialCalling(row)" v-has="['c-calling-record-specialCall']" type="success"
                  label="呼叫"></c-link>
          <c-link @click="onViewBooking(row)" v-has="['c-booking-delivery-detail', 'c-booking-pickup-detail']"
                  type="primary" label="查看"></c-link>
        </div>
      </template>
    </c-table>
    <CallingModal ref="CallingModal" @ok="onCallingResult"/>
    <AllocationModal ref="AllocationModal"/>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import CallingModal from "./components/CallingModal.vue";
import AllocationModal from "./components/AllocationModal.vue";
import {mapGetters} from "vuex";
import {debounce} from 'lodash'

export default {
  props: [],

  data() {
    return {
      business_loading: false,
      car_business_loading: false,
      business_list: [],
      car_business_list: [],
      all_car_business_list: [],
      car_business_keyword: "",
      countMap: {},
      loadCallBack: this.getCount,
      columns: [
        {label: "预约业务名称", prop: "business_name"},
        {label: "车辆业务类型", prop: "business_list"},
        {
          label: "车辆类型",
          prop: "vehicle_type",
          formatData: row => {
            const type = this.vehicleTypes.find(
                type => type.id === row.vehicle_type
            );
            return type ? type.name : "--";
          }
        },
        {label: "订单号", prop: "order_code"},
        {label: "物料类型", prop: "chip_type"},
        {label: "车辆号", prop: "license_plate"},
        {
          label: "预约状态",
          prop: "state",
          formatData: row => {
            return this.businessState[row.state] || "--";
          }
        },
        {
          label: "登记时间",
          prop: "report_time"
        },
        {label: "操作", prop: "action"}
      ],
      fetchDataEvent: params =>
          this.$common.http({
            url: "/api/queue/admin/query_calling_booking",
            data: params
          })
    };
  },

  computed: {
    ...mapGetters(["businessState", "vehicleTypes"])
  },
  watch: {
    // 预约业务变化时同步车辆业务类型范围，避免保留不属于当前父业务的筛选条件。
    "queryParam.business_id"() {
      this.syncCarBusinessListByBusiness();
    }
  },

  components: {
    CallingModal,
    AllocationModal
  },

  mixins: [initListMinxin, mixinTableLyout],

  beforeCreate() {
  },

  created() {
    this.getBusinessList();
    this.loadAllCarBusinessList();
  },

  beforeMount() {
  },

  mounted() {
  },

  activated() {
  },

  deactivated() {
  },

  methods: {
    onViewBooking(row) {
      const {business_list} = row;
      let type = "";
      business_list.map(item => {
        type = item.type;
      });
      if (type === 11) {
        this.$router.push({
          path:
              "/rhqy/service/AppointDeliveryRecord/Detail/" + row.booking_info_id
        });
      }
      if (type === 12) {
        this.$router.push({
          path: "/rhqy/service/AppointPickup/Detail/" + row.booking_info_id
        });
      }
    },
    onSpecialCalling(row) {
      let selection = [];
      if (row) {
        selection.push(row.booking_id);
      } else {
        selection = this.rowKeySelection;
      }
      if (selection.length === 0) {
        this.$message({message: "请选择要特殊叫号的记录！", type: "warning"});
        return;
      }
      this.$confirm(
          `确认叫号已选中的${!row ? selection.length + "条" : ""
          }记录？`,
          "叫号确认"
      ).then(async _ => {
        try {
          const res = await this.$common.http({
            url: "/api/queue/admin/special_call_booking",
            data: {
              booking_ids: selection.join(",")
            }
          });
          this.onCallingResult(res.data.data);
        } catch (error) {
          console.log("error", error);
        }
      });
    },
    onCalling() {
      this.$refs.CallingModal.show();
    },
    async getCount() {
      const res = await this.$common.http({
        url: "/api/queue/admin/count_auth_booking"
      });
      this.countMap = res.data.data;
    },
    onCallingResult(data) {
      const {uuid, handle_num} = data;
      this.refreshData();
      this.$confirm(`已成功叫号${handle_num}条！`, "叫号结果", {
        confirmButtonText: "继续叫号",
        cancelButtonText: "查看分配结果",
        type: "warning"
      }).catch(() => {
        this.$refs.AllocationModal.show(uuid);
      });
    },
    getBusinessList: debounce(async function (query) {
      try {
        this.business_loading = true;
        const res = await this.$common.http({
          url: "/api/queue/admin/query_business",
          data: {
            keyword: query || "",
            page: 1,
            page_size: 999,
            is_parent: 0,
            state: 1
          }
        });
        this.business_list = res.data.data.data;
        this.business_loading = false;
      } catch (error) {

      }
    }, 500),
    getCarBusinessList: debounce(async function (query) {
      this.car_business_keyword = query || "";
      this.syncCarBusinessListByBusiness();
    }, 300),
    // 预约业务变化时清理车辆业务类型关键字，并复用同一套联动逻辑刷新子业务下拉。
    onBusinessChange() {
      this.car_business_keyword = "";
      this.syncCarBusinessListByBusiness();
    },
    // 根据预约业务和车辆业务关键字同步车辆业务类型下拉选项。
    syncCarBusinessListByBusiness() {
      const businessId = this.queryParam.business_id;
      const keyword = this.car_business_keyword;
      const businessScopeList = businessId
          ? this.all_car_business_list.filter(item => item.pid === businessId)
          : [...this.all_car_business_list];
      let nextList = [...businessScopeList];

      if (keyword) {
        nextList = nextList.filter(item => (item.name || "").includes(keyword));
      }

      this.car_business_list = nextList;

      // 只按预约业务范围清理已选值，避免搜索关键字临时过滤时误删已选车辆业务类型。
      const selected = Array.isArray(this.queryParam.car_business_ids)
          ? this.queryParam.car_business_ids
          : [];
      const validIds = businessScopeList.map(item => item.id);
      const nextSelected = selected.filter(id => validIds.includes(id));
      if (nextSelected.length !== selected.length) {
        this.$set(this.queryParam, "car_business_ids", nextSelected);
      }
    },
    // 初始化车辆业务类型全集，后续联动都基于本地缓存过滤。
    async loadAllCarBusinessList() {
      try {
        this.car_business_loading = true;
        const res = await this.$common.http({
          url: "/api/queue/admin/query_business",
          data: {
            keyword: "",
            page: 1,
            page_size: 999,
            is_parent: 1,
            state: 1
          }
        });
        this.all_car_business_list = res.data.data.data;
        this.syncCarBusinessListByBusiness();
        this.car_business_loading = false;
      } catch (error) {

      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "./assets/css/common";

.viewsrhqy_Calling {
  .el-form-item {
    margin-bottom: 10px !important;
  }
}
</style>
<style lang="less">
.viewsrhqy_Calling {
}
</style>
